export default __webpack_public_path__ + "static/media/hinge3.6510d361.jpg";